export const SET_STRATEGIES = "SET_STRATEGIES";
export const SET_COMPARE_STRATEGIES = "SET_COMPARE_STRATEGIES";

export const ADD_TO_COMPARE = "ADD_TO_COMPARE";
export const REMOVE_FROM_COMPARE = "REMOVE_FROM_COMPARE";

export const CLEAR_STRATEGIES = "CLEAR_STRATEGIES";

export const RECIEVE_TREATMENTGROUPS = "RECIEVE_TREATMENTGROUPS";
export const SET_TREATMENTGROUPS = "SET_TREATMENTGROUPS";
export const SET_TREATMENTGROUP_ID = "SET_TREATMENTGROUP_ID";